import { useField } from "formik"
import { FileUpload } from "primereact/fileupload"

//styles
import styles from "../../../styles/Form-Inputs.module.css"
import docsTemplateStyles from "../../../styles/documentSigning/DocSign.templates.module.css"

//PrimeReact
import { InputText } from "primereact/inputtext"
import { Tooltip } from "primereact/tooltip"

export default function NewTemplateDocumentUploadInput({
  fieldName,
  label,
  required,
  helpText,
}) {
  const [field, meta, helper] = useField(fieldName)

  const uploadFileHandler = (files) => {
    const newFileList = [...field.value, ...files.files]
    helper.setValue(newFileList)
    files.options.clear()
    return true
  }

  function removeDocument(file) {
    const index = field.value.indexOf(file)
    const newFileList = field.value.slice()
    newFileList.splice(index, 1)
    helper.setValue(newFileList)
  }

  function ShowDocuments() {
    if (field.value.length === 0) {
      return (
        <InputText
          placeholder="No documents added"
          disabled
          className={docsTemplateStyles.addedOptions}
        />
      )
    } else {
      return field.value.map((value, index) => {
        return (
          <div className={docsTemplateStyles.fileUploadGroup} key={index}>
            <InputText
              value={value.name}
              disabled
              className={docsTemplateStyles.addedOptions}
            />
            <button
              type="button"
              className={`btn template-t-tip ${docsTemplateStyles.removeOption}`}
              data-pr-tooltip={"Remove document"}
              data-pr-position="bottom"
              onClick={() => {
                removeDocument(value)
              }}
            >
              <span className={`material-icons`}>{"delete"}</span>
            </button>
          </div>
        )
      })
    }
  }

  return (
    <div className={styles.field}>
      <Tooltip target=".template-t-tip" />
      <label>
        {label} {required ? <span style={{ color: "red" }}> * </span> : null}
      </label>
      <div className="col-12 md:col-10">
        {helpText ? (
          <div style={{ marginBottom: "10px" }}>
            <small style={{ color: "gray" }}>{helpText}</small>
          </div>
        ) : null}
        <ShowDocuments />
        {meta.touched && meta.error ? (
          <label id={`${fieldName}-error`} className={styles.errFieldMsg}>
            {meta.error}
          </label>
        ) : null}
        <FileUpload
          mode="basic"
          accept="application/pdf"
          customUpload={true}
          auto={true}
          multiple={true}
          uploadHandler={uploadFileHandler}
          chooseLabel="Add Document"
          className={docsTemplateStyles.addOptionButton}
        />
      </div>
    </div>
  )
}
